// Redbee's Exposure API is CORS-open and unrelated to our backend/auth, so this bypasses
// apiClient/useApiRequest. Anonymous auth + entitlement, returning the AV master playlist.
const REDBEE_BASE_URL = 'https://exposure.api.redbee.live/v2/customer/UKParliament/businessunit/ParliamentLive';

const getAnonymousSessionToken = async (signal) => {
  const response = await fetch(`${REDBEE_BASE_URL}/auth/anonymous`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      device: { type: 'WEB', name: 'Windows chrome 131' },
      deviceId: crypto.randomUUID(),
    }),
    signal,
  });
  if (!response.ok) throw new Error(`Redbee anonymous auth failed (${response.status}).`);
  const { sessionToken } = await response.json();
  return sessionToken;
};

// HLS master playlist URL for a parliamentEventId, or null if none is entitled.
const getParliamentVideoStreamUrl = async (parliamentEventId, { signal } = {}) => {
  if (!parliamentEventId) return null;
  const sessionToken = await getAnonymousSessionToken(signal);
  const response = await fetch(
    `${REDBEE_BASE_URL}/entitlement/${parliamentEventId}/play?supportedFormats=dash%2Chls%2Cmss%2Cmp3`,
    { headers: { Authorization: `Bearer ${sessionToken}` }, signal }
  );
  if (!response.ok) throw new Error(`Redbee entitlement lookup failed (${response.status}).`);
  const { formats } = await response.json();
  const hlsStream = formats?.find((format) => format.format === 'HLS');
  return hlsStream?.mediaLocator ?? null;
};

export default getParliamentVideoStreamUrl;
